export enum SvcNowFuncTab {
    Register = 'Register',
    RoomMapping = 'RoomMapping',
    CalendarConfig = 'CalendarConfig'
}

export enum PairingContentAssignMode {
    Policy = 'Policy',
    Manual = 'Manual'
}